import type {TangentNode} from "#material/cycles/types"

export const cyclesAxis = (axis?: "X" | "Y" | "Z"): TangentNode["parameters"]["axis"] | undefined => {
    if (!axis) {
        return undefined
    }

    switch (axis) {
        case "X":
            return "x"
        case "Y":
            return "y"
        case "Z":
            return "z"
    }
}

export const cyclesDirectionType = (directionType?: "UV_MAP" | "RADIAL"): TangentNode["parameters"]["direction_type"] | undefined => {
    if (!directionType) {
        return undefined
    }

    switch (directionType) {
        case "UV_MAP":
            return "uv_map"
        case "RADIAL":
            return "radial"
    }
}
